// import { Flag, TriangleAlert, User, UserPlus, UserRoundCheck, UsersRound } from 'lucide-react'
// import React, { useCallback, useEffect } from 'react'
// import { useDispatch, useSelector } from 'react-redux'
// import { GetDashboardDataApi } from '../redux/actions/dashboard/GetDashboardDataAction';
// import { PulseLoader } from 'react-spinners';

// const Dashboard = () => {
//     const dispatch = useDispatch();

//     const { response, loading, error } = useSelector((state) => state.dashboard);

//     const fetchDashboardData = useCallback(async () => {
//         try {
//             await dispatch(GetDashboardDataApi())
//         } catch (error) {
//             console.log('error in fetching dashboard data')
//         }
//     }, [])

//     useEffect(() => {
//         fetchDashboardData()
//     }, [fetchDashboardData]);

//     return (
//         <>
//             {
//                 loading
//                     ? (
//                         <div style={{ height: '70vh' }} className='d-flex align-items-center justify-content-center'>
//                             <PulseLoader size={25} color="#0f0a30" />
//                         </div>
//                     ) : error ? (
//                         <div style={{ height: '70vh' }} className='d-flex align-items-center justify-content-center'>
//                             <p className='text-danger'>Something went wrong</p>
//                         </div>
//                     ) :
//                         <>
//                             <div className="page_top_section">
//                                 <div className="page-header">
//                                     <div className="page-header-left d-flex align-items-center">
//                                         <div className="page-header-title">
//                                             <h1 className="fs-3 text-black fw-semibold  mb-0 text-capitalize">dashboard</h1>
//                                             <p className='text-clr mb-0'>Welcome back! Here's what's happening with your platform today.</p>
//                                         </div>
                                       
//                                     </div>
                                    
//                                 </div>
//                             </div>

//                             < section className="main-section spacer" >
//                                 <div className="container">
//                                     <div className="row">
//                                         <div className="col-xl-12">
//                                             <div className="row gx-4 gy-4">
//                                                 <div className="col-sm-6 col-md-4 col-xl-3">
//                                                     <div className="dash-num-info-cards">
//                                                         <div className="dash-num-info-cards-header">
//                                                             <div className="num-info-content-box">
//                                                                 <h2>Total Users</h2>
//                                                                 <span className="num-values">{response?.data?.totalUser || 0}</span>
//                                                             </div>
//                                                             <div className="num-info-icon-box">
//                                                                 <UsersRound />
//                                                             </div>

//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-sm-6 col-md-4 col-xl-3">
//                                                     <div className="dash-num-info-cards">
//                                                         <div className="dash-num-info-cards-header">
//                                                             <div className="num-info-content-box">
//                                                                 <h2>New Users Today</h2>
//                                                                 <span className="num-values">{response?.data?.newUserToday?.count || 0}</span>
//                                                                 <p className='mb-0 fs-14 text-grey'>This Week:{response?.data?.newUserToday?.this_week || 0}</p>
//                                                             </div>
//                                                             <div className="num-info-icon-box">
//                                                                 <UserPlus />
//                                                             </div>

//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-sm-6 col-md-4 col-xl-3">
//                                                     <div className="dash-num-info-cards">
//                                                         <div className="dash-num-info-cards-header">
//                                                             <div className="num-info-content-box">
//                                                                 <h2>Active Users</h2>
//                                                                 <span className="num-values">{response?.data?.activeUser?.count || 0}</span>
//                                                                 <p className='mb-0 fs-14 text-grey'>This Week:{response?.data?.activeUser?.this_week || 0}</p>
//                                                             </div>
//                                                             <div className="num-info-icon-box">
//                                                                 <UserRoundCheck />
//                                                             </div>

//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-sm-6 col-md-4 col-xl-3">
//                                                     <div className="dash-num-info-cards">
//                                                         <div className="dash-num-info-cards-header">
//                                                             <div className="num-info-content-box">
//                                                                 <h2>Pending Reports</h2>
//                                                                 <span className="num-values">{response?.data?.pending_reports || 0}</span>
//                                                             </div>
//                                                             <div className="num-info-icon-box">
//                                                                 <TriangleAlert />
//                                                             </div>

//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>
//                                     <div className="row mt-4">
//                                         <div className="col-xl-12">
//                                             <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 gx-sm-4 gx-lg-4 gy-4">
//                                                 <div className="col">
//                                                     <div className='dash-graph-cards'>
//                                                         <div className="dash-info-content-blk">
//                                                             <ul className="dash-info-listing">
//                                                                 <li>
//                                                                     <h2 className="dash-info-listing-title fs-5 fw-semibold mb-0">Today's Content</h2>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span className="dash-info-listing-title">New Posts</span>
//                                                                     <span className="dash-info-listing-value">{response?.data?.todaysContent?.newPosts || 0}</span>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span className="dash-info-listing-title">New Events</span>
//                                                                     <span className="dash-info-listing-value">{response?.data?.todaysContent?.newEvents || 0}</span>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span className="dash-info-listing-title">New Challenges</span>
//                                                                     <span className="dash-info-listing-value">{response?.data?.todaysContent?.newChallenges || 0}</span>
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="col">
//                                                     <div className='dash-graph-cards'>
//                                                         <div className="dash-info-content-blk">
//                                                             <ul className="dash-info-listing">
//                                                                 <li>
//                                                                     <h2 className="dash-info-listing-title fs-5 fw-semibold mb-0">System Status</h2>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span className="dash-info-listing-title">Server Status</span>
//                                                                     <span className="dash-info-listing-value">{response?.data?.systemStatus?.serverStatus || 0}</span>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span className="dash-info-listing-title">Uptime</span>
//                                                                     <span className="dash-info-listing-value">{response?.data?.systemStatus?.uptime || 0}</span>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span className="dash-info-listing-title">Response Time</span>
//                                                                     <span className="dash-info-listing-value">{response?.data?.systemStatus?.resposne_time || 0}</span>
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="col">
//                                                     <div className='dash-graph-cards'>
//                                                         <div className="dash-info-content-blk">
//                                                             <ul className="dash-info-listing">
//                                                                 <li>
//                                                                     <h2 className="dash-info-listing-title fs-5 fw-semibold mb-0">Engagement Today</h2>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span className="dash-info-listing-title">Total Likes</span>
//                                                                     <span className="dash-info-listing-value">{response?.data?.engagementToday?.totalLikes || 0}</span>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span className="dash-info-listing-title">Chat Messages
//                                                                     </span>
//                                                                     <span className="dash-info-listing-value">{response?.data?.engagementToday?.chatmessages || 0}</span>
//                                                                 </li>
//                                                                 <li>
//                                                                     <span className="dash-info-listing-title">Comments</span>
//                                                                     <span className="dash-info-listing-value">{response?.data?.engagementToday?.comments || 0}</span>
//                                                                 </li>
//                                                             </ul>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>

//                                 </div>
//                             </section >
//                         </>
//             }
//         </>

//     )
// }

// export default Dashboard




import { Flag, TriangleAlert, User, UserPlus, UserRoundCheck, UsersRound } from 'lucide-react';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetDashboardDataApi } from '../redux/actions/dashboard/GetDashboardDataAction';
import { PulseLoader } from 'react-spinners';
import { Bar, Line, Pie } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, LineElement, PointElement, ArcElement, Title, Tooltip, Legend } from 'chart.js';

// Register Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, ArcElement, Title, Tooltip, Legend);

const Dashboard = () => {
  const dispatch = useDispatch();
  const { response, loading, error } = useSelector((state) => state.dashboard);

  const fetchDashboardData = useCallback(async () => {
    try {
      await dispatch(GetDashboardDataApi());
    } catch (error) {
      console.log('Error fetching dashboard data:', error);
    }
  }, [dispatch]);

  useEffect(() => {
    fetchDashboardData();
  }, [fetchDashboardData]);

  if (loading) {
    return (
      <div style={{ height: '70vh' }} className="d-flex align-items-center justify-content-center">
        <PulseLoader size={25} color="#0f0a30" />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ height: '70vh' }} className="d-flex align-items-center justify-content-center">
        <p className="text-danger">Something went wrong</p>
      </div>
    );
  }

  if (!response?.data) {
    return (
      <div style={{ height: '70vh' }} className="d-flex align-items-center justify-content-center">
        <p>No data available</p>
      </div>
    );
  }

  const { data } = response;

  // Check-In Stats Bar Chart
  const checkInChartData = {
    labels: ['Total Check-In Users', 'Challenge Check-Ins', 'Event Check-Ins', 'Active Users This Week'],
    datasets: [
      {
        label: 'Check-In Stats',
        data: [
          data.checkInStats?.totalCheckInUsers || 0,
          data.checkInStats?.challengeCheckIns || 0,
          data.checkInStats?.eventCheckIns || 0,
          data.checkInStats?.activeUsersThisWeek || 0,
        ],
        backgroundColor: 'rgba(75, 192, 192, 0.6)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
      },
    ],
  };

  // Growth Metrics Line Chart
  const growthChartData = {
    labels: ['New Signups', 'Active Users', 'Retention Rate (%)'],
    datasets: [
      {
        label: 'Growth Metrics',
        data: [
          data.growthMetrics?.newSignups || 0,
          data.growthMetrics?.activeUsers || 0,
          data.growthMetrics?.retentionRate || 0,
        ],
        borderColor: 'rgba(255, 99, 132, 1)',
        backgroundColor: 'rgba(255, 99, 132, 0.2)',
        fill: true,
        tension: 0.4,
      },
    ],
  };

  // Content Stats Pie Chart (Today's Content)
  const contentChartData = {
    labels: ['New Posts', 'New Events', 'New Challenges'],
    datasets: [
      {
        label: 'Content Today',
        data: [
          data.todaysContents?.newPosts || 0,
          data.todaysContents?.newEvents || 0,
          data.todaysContents?.newChallenges || 0,
        ],
        backgroundColor: [
          'rgba(54, 162, 235, 0.6)',
          'rgba(255, 206, 86, 0.6)',
          'rgba(153, 102, 255, 0.6)',
        ],
        borderColor: [
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(153, 102, 255, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  // User Behavior Bar Chart
  const userBehaviorChartData = {
    labels: ['Avg Session Time', 'Match Requests Sent', 'Match Requests Accepted'],
    datasets: [
      {
        label: 'User Behavior',
        data: [
          data.userBehavior?.avgSessionTime || 0,
          data.userBehavior?.matchRequestsSent || 0,
          data.userBehavior?.matchRequestsAccepted || 0,
        ],
        backgroundColor: 'rgba(153, 102, 255, 0.6)',
        borderColor: 'rgba(153, 102, 255, 1)',
        borderWidth: 1,
      },
    ],
  };

  // Most Liked Challenges Bar Chart
  const mostLikedChallengesChartData = {
    labels: data.todaysContent?.mostLikedChallenges?.map(ch => ch.title.slice(0, 20) + (ch.title.length > 20 ? '...' : '')) || [],
    datasets: [
      {
        label: 'Challenge Participation',
        data: data.todaysContent?.mostLikedChallenges?.map(ch => ch.likes) || [],
        backgroundColor: 'rgba(255, 159, 64, 0.6)',
        borderColor: 'rgba(255, 159, 64, 1)',
        borderWidth: 1,
      },
    ],
  };

  // Highest Attendance Events Bar Chart
  const highestAttendanceEventsChartData = {
    labels: data.todaysContent?.highestAttendanceEvents?.map(ev => ev.title.slice(0, 20) + (ev.title.length > 20 ? '...' : '')) || [],
    datasets: [
      {
        label: 'Event Attendance',
        data: data.todaysContent?.highestAttendanceEvents?.map(ev => ev.count) || [],
        backgroundColor: 'rgba(54, 162, 235, 0.6)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1,
      },
    ],
  };

  return (
    <>
      <div className="page_top_section">
        <div className="page-header">
          <div className="page-header-left d-flex align-items-center">
            <div className="page-header-title">
              <h1 className="fs-3 text-black fw-semibold  mb-0 text-capitalize">dashboard</h1>
              <p className='text-clr mb-0'>! Here's what's happening with your platform today.</p>
            </div>
          </div>
        </div>
      </div>

      <section className="main-section spacer">
        <div className="container">
          {/* Original Metrics Cards */}
          <div className="row">
            <div className="col-xl-12">
              <div className="row gx-4 gy-4">
                <div className="col-sm-6 col-md-4 col-xl-3">
                  <div className="dash-num-info-cards">
                    <div className="dash-num-info-cards-header">
                      <div className="num-info-content-box">
                        <h2>Total Users</h2>
                        <span className="num-values">{data?.totalUser || 0}</span>
                      </div>
                      <div className="num-info-icon-box">
                        <UsersRound />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3">
                  <div className="dash-num-info-cards">
                    <div className="dash-num-info-cards-header">
                      <div className="num-info-content-box">
                        <h2>New Users Today</h2>
                        <span className="num-values">{data?.newUserToday || 0}</span>
                        <p className='mb-0 fs-14 text-grey'>This Week:{data?.newUserThisWeek || 0}</p>
                      </div>
                      <div className="num-info-icon-box">
                        <UserPlus />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3">
                  <div className="dash-num-info-cards">
                    <div className="dash-num-info-cards-header">
                      <div className="num-info-content-box">
                        <h2>Active Users</h2>
                        <span className="num-values">{data?.activeUserToday || 0}</span>
                        <p className='mb-0 fs-14 text-grey'>This Week:{data?.activeUserThisWeek || 0}</p>
                      </div>
                      <div className="num-info-icon-box">
                        <UserRoundCheck />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3">
                  <div className="dash-num-info-cards">
                    <div className="dash-num-info-cards-header">
                      <div className="num-info-content-box">
                        <h2>Pending Reports</h2>
                        <span className="num-values">{data?.pendingReports || 0}</span>
                      </div>
                      <div className="num-info-icon-box">
                        <TriangleAlert />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Info Cards */}
          <div className="row mt-4">
            <div className="col-xl-12">
              <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 gx-sm-4 gx-lg-4 gy-4">
                <div className="col">
                  <div className='dash-graph-cards'>
                    <div className="dash-info-content-blk">
                      <ul className="dash-info-listing">
                        <li>
                          <h2 className="dash-info-listing-title fs-5 fw-semibold mb-0">Today's Content</h2>
                        </li>
                        <li>
                          <span className="dash-info-listing-title">New Posts</span>
                          <span className="dash-info-listing-value">{data?.todaysContents?.newPosts || 0}</span>
                        </li>
                        <li>
                          <span className="dash-info-listing-title">New Events</span>
                          <span className="dash-info-listing-value">{data?.todaysContents?.newEvents || 0}</span>
                        </li>
                        <li>
                          <span className="dash-info-listing-title">New Challenges</span>
                          <span className="dash-info-listing-value">{data?.todaysContents?.newChallenges || 0}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className='dash-graph-cards'>
                    <div className="dash-info-content-blk">
                      <ul className="dash-info-listing">
                        <li>
                          <h2 className="dash-info-listing-title fs-5 fw-semibold mb-0">System Status</h2>
                        </li>
                        <li>
                          <span className="dash-info-listing-title">Server Status</span>
                          <span className="dash-info-listing-value">{data?.systemStatus?.serverStatus || 0}</span>
                        </li>
                        <li>
                          <span className="dash-info-listing-title">Uptime</span>
                          <span className="dash-info-listing-value">{data?.systemStatus?.uptime || 0}</span>
                        </li>
                        <li>
                          <span className="dash-info-listing-title">Response Time</span>
                          <span className="dash-info-listing-value">{data?.systemStatus?.resposne_time || 0}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className='dash-graph-cards'>
                    <div className="dash-info-content-blk">
                      <ul className="dash-info-listing">
                        <li>
                          <h2 className="dash-info-listing-title fs-5 fw-semibold mb-0">Engagement Today</h2>
                        </li>
                        <li>
                          <span className="dash-info-listing-title">Total Likes</span>
                          <span className="dash-info-listing-value">{data?.engagementToday?.totalLikes || 0}</span>
                        </li>
                        {/* <li>
                          <span className="dash-info-listing-title">Chat Messages</span>
                          <span className="dash-info-listing-value">{data?.engagementToday?.chatmessages || 0}</span>
                        </li> */}
                        <li>
                          <span className="dash-info-listing-title">Comments</span>
                          <span className="dash-info-listing-value">{data?.engagementToday?.comments || 0}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* New Graphs Section */}
          <div className="row mt-5">
            <div className="col-xl-12">
              <h2 className="fs-3 text-black fw-semibold mb-4">Analytics Overview</h2>
              <div className="row g-4">
                <div className="col-md-6 col-lg-4">
                  <div className="dash-graph-cards" style={{ padding: '20px' }}>
                    <h3 className="dash-info-listing-title fs-5 fw-semibold mb-3">Check-In Stats</h3>
                    <Bar
                      data={checkInChartData}
                      options={{
                        responsive: true,
                        plugins: { legend: { position: 'top' }, title: { display: true, text: 'Check-In Statistics' } },
                        scales: { y: { beginAtZero: true } },
                      }}
                      height={250}
                    />
                    <ul className="dash-info-listing mt-3">
                      <li>
                        <span className="dash-info-listing-title">Avg Check-Ins Per User</span>
                        <span className="dash-info-listing-value">{data.checkInStats?.avgCheckInsPerUser || '0.00'}</span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="col-md-6 col-lg-4">
                  <div className="dash-graph-cards" style={{ padding: '20px' }}>
                    <h3 className="dash-info-listing-title fs-5 fw-semibold mb-3">Growth Metrics</h3>
                    <Line
                      data={growthChartData}
                      options={{
                        responsive: true,
                        plugins: { legend: { position: 'top' }, title: { display: true, text: 'Growth Metrics' } },
                        scales: { y: { beginAtZero: true } },
                      }}
                      height={250}
                    />
                  </div>
                </div>

                <div className="col-md-6 col-lg-4">
                  <div className="dash-graph-cards" style={{ padding: '20px' }}>
                    <h3 className="dash-info-listing-title fs-5 fw-semibold mb-3">Content Created Today</h3>
                    <Pie
                      data={contentChartData}
                      options={{
                        responsive: true,
                        plugins: { legend: { position: 'top' }, title: { display: true, text: 'Content Created Today' } },
                      }}
                      height={250}
                    />
                  </div>
                </div>

                <div className="col-md-6 col-lg-4">
                  <div className="dash-graph-cards" style={{ padding: '20px' }}>
                    <h3 className="dash-info-listing-title fs-5 fw-semibold mb-3">Most Liked Challenges</h3>
                    <Bar
                      data={mostLikedChallengesChartData}
                      options={{
                        responsive: true,
                        plugins: { legend: { position: 'top' }, title: { display: true, text: 'Challenge Participation' } },
                        scales: { y: { beginAtZero: true } },
                      }}
                      height={250}
                    />
                  </div>
                </div>

                <div className="col-md-6 col-lg-4">
                  <div className="dash-graph-cards" style={{ padding: '20px' }}>
                    <h3 className="dash-info-listing-title fs-5 fw-semibold mb-3">Highest Attendance Events</h3>
                    <Bar
                      data={highestAttendanceEventsChartData}
                      options={{
                        responsive: true,
                        plugins: { legend: { position: 'top' }, title: { display: true, text: 'Event Attendance' } },
                        scales: { y: { beginAtZero: true } },
                      }}
                      height={250}
                    />
                  </div>
                </div>

                <div className="col-md-6 col-lg-4">
                  <div className="dash-graph-cards" style={{ padding: '20px' }}>
                    <h3 className="dash-info-listing-title fs-5 fw-semibold mb-3">User Behavior</h3>
                    <Bar
                      data={userBehaviorChartData}
                      options={{
                        responsive: true,
                        plugins: { legend: { position: 'top' }, title: { display: true, text: 'User Behavior Metrics' } },
                        scales: { y: { beginAtZero: true } },
                      }}
                      height={250}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Dashboard;